import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=40b3de51&scoped=true&lang=html"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b3de51",
  null
  
)

export default component.exports